<template>
  <div class="orm-mb-16 orm-col-xs-12" v-if="filter">
    <div
        class="orm-caroffers__element orm-px-32 orm-xs-py-24 orm-py-40"
        :class="isOffer ? 'orm-caroffers__element--offer' : ''"
    >
      <div class="orm-row">
        <div
            class="orm-col-xs-12 orm-col-sm-12 orm-col-md-4 orm-mb-16 orm-border-right"
        >
          <div
              class="orm-slider__image__container orm-px-0"
              :style="[images ? { paddingBottom: 0 } : { paddingBottom: '75%' }]"
          >
            <Slider v-if="images" :images="images" :autoplay="true" />
          </div>
          <div class="orm-carequip text-center">
            <p class="orm-equip__txt__icons orm-mt-8">
              <equipIcon :data="data.features" :shortlist="true" />
            </p>
            <p class="orm-equip__txt__freemiles" v-if="price.length > 0">
              <span v-if="price && !price[0].all_km_inclusive"
              >{{ i18n("cargroup/inclusive") }} {{ price[0].km_free }}
                {{ i18n("cargroup/freeKilometers") }}</span
              >
              <span v-else
              >{{ i18n("cargroup/inclusive") }}
                {{ i18n("cargroup/unlimited") }}
                {{ i18n("cargroup/freeKilometers") }}</span
              >
            </p>
          </div>
        </div>
        <div
            class="orm-col-xs-12 orm-col-sm-12 orm-col-md-8 orm-col-lg-6 orm-px-8 orm-pl-md-32 orm-pr-md-24"
        >
          <div>
            <h2 class="orm-headline__h2 orm-headline__h2--list">
              {{ stripHTML(data[env.VUE_APP_RESERVATION_CARGROUP]) }}
            </h2>
            <p
                class="orm-headline__h2__subheadline--list orm-pb-16 orm-relative"
            >
              {{ stripHTML(data[env.VUE_APP_RESERVATION_CARCATEGORY]) }}
              <i class="fal fa-question-circle orm-cargroup__tooltip"
              ><span
                  class="orm-cargroup__tooltip_text orm-cargroup__tooltip-bottom--list"
              >{{ i18n("cargroup/noguarantee") }}</span
              ></i
              >
            </p>
            <div
                v-html="data[env.VUE_APP_RESERVATION_CARTEXT]"
                class="orm-cardescription orm-mb-24"
            ></div>
          </div>
        </div>
        <div
            class="orm-col-xs-12 orm-col-md-12 orm-col-lg-2 text-right orm-pr-8 orm-pt-16"
        >
          <div class="orm-cardetails--flex">
            <div
                class="orm-cardetails__container orm-cardetails__container--bottom"
            >
              <div class="orm-cardetails end-xs" v-if="price.length > 0 && !loading">
                <div class="orm-carprice">
                  <div v-if="priceData">
                    <p class="orm-price__txt__surtitle">
                      {{ priceData.main.label }}
                    </p>
                    <p class="orm-price__txt" :class="{ 'orm-price__txt--offer': isOffer }">
                      <span style="white-space: nowrap">
                        {{ formatPrice(priceData.main.value) }}
                      </span>
                    </p>
                    <p v-if="priceData.sub.text" class="orm-price__txt__subtitle">
                      {{ priceData.sub.text }}
                    </p>
                  </div>
                </div>
              </div>
              <button
                  v-if="price.length > 0 && !loading"
                  @click="setCarGroup(car)"
                  class="orm-button__cta wide"
                  :class="isOffer ? 'orm-button__cta--offer' : 'outline'"
              >
                {{
                  isOffer
                      ? i18n("cargroup/select_offer") || "Angebot sichern"
                      : i18n("cargroup/select")
                }}<i
                  v-if="isOffer"
                  class="orm-button__cta--offer-icon far fa-stars"
              ></i>
              </button>

              <div class="orm-carprice">
                <div
                    class="orm-preload-page orm-preload-page-static orm-mt-64"
                    v-if="loading"
                >
                  <div class="orm-loader-spinner">
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </div>
                </div>
                <button
                    v-if="!loading && price.length == 0"
                    class="orm-button__cta outline small"
                    @click="openContactModal(car)"
                >
                  {{ i18n("cargroup/error/button") }}
                </button>
                <div
                    class="orm-car__error"
                    v-if="price.length == 0 && !loading"
                >
                  {{ i18n("cargroup/error/price") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";
import equipIcon from "@/components/reservation/equip-icon.vue";
import Slider from "@/components/ui/image-slider.vue";
import { convertCurrency } from "@/constants/formater";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "car-list-large",
  components: { equipIcon, Slider },
  emits: ["openContact"],
  setup() {
    const userSession = store.state.userSession.LocalSession;
    return {
      userSession,
      store,
      convertCurrency,
      routeToSteps,
    };
  },
  mixins: [i18n, stripHTML],
  data() {
    return {
      car: Object,
      price: [],
      isOffer: false,
      images: null,
      show: true,
      loading: true,
      tarif: Object,
      env: process.env,
      switchTotalLongPricePosition: false,
      showNettoPrice: false,
      roundPrices: false,
      showDaysOnly: false,
      showTotalPriceOnly: false,
    };
  },
  props: {
    data: Object,
    filter: Boolean,
  },
  async mounted() {
    this.car = await JSON.parse(JSON.stringify(this.data));
    this.car.price = {};

    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
        "BORM_SHOW_NETTO_PRICE"
    );
    if (showNetto === "1") this.showNettoPrice = true;

    const pricePosition = await store.getters["ORMgeneral/GET_PARAMETER"](
        "BORM_GESAMTPREIS_FETT"
    );
    if (pricePosition === "1") this.switchTotalLongPricePosition = true;

    const roundPricesParam = await store.getters["ORMgeneral/GET_PARAMETER"](
        "ORM_STEP2_PREISE_RUNDEN"
    );
    if (roundPricesParam === "1") this.roundPrices = true;

    const showDaysOnlyParam = await store.getters["ORMgeneral/GET_PARAMETER"](
        "ORM_STEP2_SHOW_DAYS_ONLY"
    );
    if (showDaysOnlyParam === "1") this.showDaysOnly = true;

    const showTotalPriceOnlyParam = await store.getters["ORMgeneral/GET_PARAMETER"](
        "BORMLF_STEP1_SHOW_TOTALPRICE_ONLY"
    );
    if (showTotalPriceOnlyParam === "1") this.showTotalPriceOnly = true;

    this.lazyload();
  },
  computed: {
    rentalDurationInDays() {
      try {
        const startDateStr = store.getters["userSession/GET_RESERVATIONDATE_START"];
        const startTimeStr = store.getters["userSession/GET_RESERVATIONTIME_START"];
        const endDateStr = store.getters["userSession/GET_RESERVATIONDATE_END"];
        const endTimeStr = store.getters["userSession/GET_RESERVATIONTIME_END"];
        if (!startDateStr || !startTimeStr || !endDateStr || !endTimeStr) return 1;
        const startDate = new Date(`${startDateStr}T${startTimeStr}`);
        const endDate = new Date(`${endDateStr}T${endTimeStr}`);
        const differenceInMs = endDate.getTime() - startDate.getTime();
        const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
        return differenceInDays > 0 ? differenceInDays : 1;
      } catch (error) {
        console.error("Fehler bei der Berechnung der Mietdauer:", error);
        return 1;
      }
    },
    priceData() {
      const totalPrice = this.showNettoPrice ? this.tarif?.end_positions?.[0]?.total_price : this.tarif?.total_price_main_rates;
      const apiUnitPrice = this.showNettoPrice ? this.price?.[0]?.single_price : this.price?.[0]?.long_price;
      const totalLabel = this.i18n("cargroup/total");
      const unitLabel = `${this.i18n("cargroup/unitbefore")} ${this.price?.[0]?.unit} ${this.i18n("cargroup/unitafter")}`;
      const perDayLabel = this.i18n("cargroup/perday") || "pro Tag";

      if (this.showTotalPriceOnly) {
        return { main: { value: totalPrice, label: totalLabel }, sub: { text: "" } };
      }
      if (this.showDaysOnly) {
        const calculatedDailyPrice = (totalPrice && this.rentalDurationInDays) ? totalPrice / this.rentalDurationInDays : apiUnitPrice;
        return { main: { value: calculatedDailyPrice, label: perDayLabel }, sub: { text: `(${totalLabel}: ${this.formatPrice(totalPrice)})` } };
      }
      if (this.switchTotalLongPricePosition) {
        return { main: { value: totalPrice, label: totalLabel }, sub: { text: `${unitLabel}: ${this.formatPrice(apiUnitPrice)}` } };
      }
      return { main: { value: apiUnitPrice, label: unitLabel }, sub: { text: `(${totalLabel}: ${this.formatPrice(totalPrice)})` } };
    },
  },
  methods: {
    formatPrice(value) {
      let priceToFormat = Number(value) || 0;
      if (this.roundPrices) {
        priceToFormat = Math.round(priceToFormat);
      }
      return this.convertCurrency(priceToFormat);
    },
    async lazyload() {
      this.images = this.car.images;
      const car = [];
      this.tarif = await store
          .dispatch("reservation/CALCULATE_PRICE", { id: this.car.id, extras: false })
          .then((res) => {
            if (!res.errors) {
              res.main_rates.forEach((element) => {
                if (element.position == 1) {
                  car.push(element);
                  if (element.is_offer) this.isOffer = true;
                }
              });
              this.loading = false;
              return res;
            } else {
              this.$emit("update:error", res);
              this.loading = false;
            }
          });
      this.price = car;
    },
    setCarGroup(car) {
      store.dispatch("userSession/SET_CARGROUP", car.id).then(() => {
        store.dispatch("reservation/SET_RESERVATION_TARIFS", this.tarif).then(() => {
          if (this.isOffer) buildDataLayer("view_promotion", {}, null);
          routeToSteps(this, 2);
        });
      });
    },
    openContactModal(car) {
      this.$emit("openContact", car);
    },
  },
});
</script>